module.exports = __webpack_public_path__ + "static/media/logo.a7339cc1.svg";